// extracted by mini-css-extract-plugin
export var root = "yxjB";
export var rootArrow = "_56Sx";
export var rootArrowNext = "JdzK";
export var rootArrowPrev = "a+w9";
export var rootArrows = "AN9s";
export var rootCarousel = "CEGk";
export var rootCarouselContainer = "wG+9";
export var rootCarouselViewport = "+ksb";
export var rootContainer = "CdSK";
export var rootDescription = "QTMn";
export var rootDot = "kp8K";
export var rootDotActive = "_0N+8";
export var rootDots = "_6O1P";
export var rootHeading = "E+gV";
export var rootLogo = "iKT4";
export var rootLogoIcon = "-mG+";
export var rootMain = "VwKv";
export var rootSlide = "dnZW";
export var rootText = "o3Hy";